export default "__VITE_ASSET__QukVwEmV__"